import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { ArrowLeft, ListChecks } from "@phosphor-icons/react";

const SYLLABUS = {
    kpsc: {
        prelims: {
            title: "KPSC KAS · Prelims Syllabus",
            papers: [
                {
                    name: "Paper I — General Studies",
                    marks: 200,
                    topics: [
                        "Current events of state, national & international importance",
                        "History of India and Indian National Movement",
                        "Karnataka History, Culture, Heritage and Karnataka's role in Indian Independence",
                        "Indian and World Geography — physical, social, economic",
                        "Karnataka Geography — physical, agricultural, industrial",
                        "Indian Polity, Constitution, Governance and Panchayati Raj",
                        "Economic and Social Development — Poverty, Inclusion, Demographics",
                        "General issues on Environmental Ecology, Biodiversity, Climate Change",
                        "General Science",
                    ],
                },
                {
                    name: "Paper II — General Studies (Aptitude & Reasoning)",
                    marks: 200,
                    topics: [
                        "Comprehension",
                        "Logical Reasoning and Analytical Ability",
                        "Decision Making and Problem Solving",
                        "General Mental Ability",
                        "Basic Numeracy (Class X level)",
                        "Data Interpretation (charts, tables, graphs)",
                        "Kannada Language Comprehension Skills (Class X level)",
                        "English Language Comprehension Skills (Class X level)",
                    ],
                },
            ],
        },
        mains: {
            title: "KPSC KAS · Mains Syllabus",
            papers: [
                { name: "Paper I — Kannada (Qualifying)", marks: 150, topics: ["Essay, Comprehension, Precis, Translation"] },
                { name: "Paper II — English (Qualifying)", marks: 150, topics: ["Essay, Comprehension, Precis, Translation"] },
                { name: "Paper III — Essay", marks: 250, topics: ["Two essays on contemporary state, national, and international issues"] },
                { name: "Paper IV — GS-I: History, Culture, Geography", marks: 250, topics: ["Karnataka & Indian History", "Cultural heritage", "World & Indian Geography"] },
                { name: "Paper V — GS-II: Constitution, Polity, Social Justice", marks: 250, topics: ["Constitutional framework", "Governance", "Social justice"] },
                { name: "Paper VI — GS-III: Economy, Development, Environment", marks: 250, topics: ["Economic development", "Environment & biodiversity", "Science & technology"] },
                { name: "Paper VII — GS-IV: Ethics, Integrity, Aptitude", marks: 250, topics: ["Ethics in public service", "Case studies"] },
            ],
        },
    },
    ksp: {
        prelims: {
            title: "KSP · Prelims Syllabus",
            papers: [
                { name: "General Knowledge & Current Affairs", marks: 100, topics: ["Karnataka current affairs", "National & International news", "Basic GK"] },
                { name: "Reasoning & Mental Ability", marks: 100, topics: ["Logical reasoning", "Analytical reasoning", "Verbal & non-verbal"] },
            ],
        },
        mains: {
            title: "KSP · Mains Syllabus",
            papers: [
                { name: "Kannada", marks: 150, topics: ["Essay", "Translation", "Precis"] },
                { name: "English", marks: 150, topics: ["Essay", "Translation", "Precis"] },
                { name: "General Studies", marks: 200, topics: ["Indian Polity", "Karnataka & Indian History", "Geography"] },
            ],
        },
    },
    kea: {
        prelims: {
            title: "KEA · Prelims Syllabus",
            papers: [
                { name: "Subject Paper", marks: 100, topics: ["As per notification: Physics / Chemistry / Mathematics / Biology (Class XI–XII NCERT)"] },
                { name: "General Awareness", marks: 50, topics: ["Karnataka current affairs", "Constitution & Governance"] },
            ],
        },
        mains: {
            title: "KEA · Mains Syllabus",
            papers: [
                { name: "Descriptive Paper", marks: 200, topics: ["Subject-wise deep-dive as per role: Engineering / Teaching / Group B/C"] },
            ],
        },
    },
};

export default function Syllabus() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const board = searchParams.get("board") || "kpsc";
    const stage = searchParams.get("stage") || "prelims";
    const data = SYLLABUS[board]?.[stage];

    if (!data) {
        return (
            <Layout>
                <div className="bento-card text-center text-slate-500">Syllabus not available for this selection.</div>
            </Layout>
        );
    }

    return (
        <Layout>
            <button onClick={() => navigate(-1)} className="btn-ghost mb-6" data-testid="syllabus-back">
                <ArrowLeft size={16} /> Back
            </button>
            <div className="mb-8 text-center">
                <div className="text-xs uppercase tracking-widest text-slate-500 mb-2">Syllabus</div>
                <h1 className="font-heading font-black text-3xl sm:text-4xl">{data.title}</h1>
            </div>

            <div className="space-y-5">
                {data.papers.map((p) => (
                    <div key={p.name} className="bento-card">
                        <div className="flex items-start justify-between gap-4 mb-3">
                            <div className="flex items-center gap-2">
                                <ListChecks size={22} weight="duotone" className="text-[#1E3A8A]" />
                                <h2 className="font-heading font-bold text-lg text-slate-900">{p.name}</h2>
                            </div>
                            <div className="font-mono text-sm text-[#1E3A8A] font-bold shrink-0">{p.marks} marks</div>
                        </div>
                        <ul className="space-y-1.5 pl-1">
                            {p.topics.map((t, i) => (
                                <li key={i} className="flex gap-2 text-sm text-slate-700">
                                    <span className="text-[#1E3A8A] font-bold shrink-0">·</span>
                                    <span>{t}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </Layout>
    );
}
